/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageSeries
 */
export interface ImageSeries {
    /**
     * 
     * @type {string}
     * @memberof ImageSeries
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ImageSeries
     */
    modelId: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ImageSeries
     */
    frames: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ImageSeries
     */
    imageWidth: number;
    /**
     * 
     * @type {number}
     * @memberof ImageSeries
     */
    imageHeight: number;
}

export function ImageSeriesFromJSON(json: any): ImageSeries {
    return ImageSeriesFromJSONTyped(json, false);
}

export function ImageSeriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageSeries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'modelId': json['modelId'],
        'frames': json['frames'],
        'imageWidth': json['imageWidth'],
        'imageHeight': json['imageHeight'],
    };
}

export function ImageSeriesToJSON(value?: ImageSeries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'modelId': value.modelId,
        'frames': value.frames,
        'imageWidth': value.imageWidth,
        'imageHeight': value.imageHeight,
    };
}


